import React from 'react'
import { Form } from 'react-bootstrap';
import Autocomplete from "react-google-autocomplete";


const PickUpLocation = ({ onSave, defaultValue, error, field }) => {

    return (
        <>
            <Form.Group className="mb-3 flex-1" id="address2">
                {/* <Form.Label>Location: <span className='text-danger'>*</span></Form.Label> */}
                <div className={`${error ? 'border border-danger' : ''}`}>
                    <Autocomplete
                        apiKey="AIzaSyAsh-ofw4XiKuvo4W1GOIutG7NpHLbp2Hw"
                        onPlaceSelected={(place) => {
                            onSave(place)
                        }}
                        options={{
                            types: ["geocode"], // Can be ['establishment', 'address', '(regions)']
                        }}
                        className="form-control w-100 border-0 custome_border_in border-bottom rounded-0 px-0"
                        defaultValue={defaultValue}
                        {...field}
                    />
                </div>
            </Form.Group>
        </>
    )
}

export default PickUpLocation